module.exports = __webpack_public_path__ + "static/hkgrotesk-bold-f8b96be9c2f570669262a567cff2e75b.woff2";